<template>
  <div>
    <!--搜索-->
    <div class="box study_top">
      <div class="wrap w1200 search">
        <dl>
          <dt>首页 - 在线考试</dt>
          <dd><input v-model="filter.title" type="text" class="put_txt paddingR_0" placeholder="搜索考试(请输入考试名称)" @keyup.13="searchByFilter(null, filter.title, null)" /><input type="button" class="put_btn" value="搜 索" @click="searchByFilter(null, filter.title, null)"/>
          </dd>
        </dl>
      </div>
    </div>
    <!--/搜索-->
    <!--筛选-->
    <div class="wrap w1200 study_cat" style="min-height: 30px;">
      <dl>
        <dt>按大分类：</dt>
        <dd><a href="javascript:;" @click="searchByFilter('', null, $event)">全部</a><a href="javascript:;" v-for="item in largeTypeList" :key="item.id" @click="searchByFilter(item.value, null, $event)">{{item.label}}</a><!--<a href="javascript:;" class="focus">员工培训</a>--></dd>
      </dl>
      <div class="clear"></div>
    </div>
    <!--/筛选-->
    <!--课件列表-->
    <div class="box study_list">
      <div class="wrap w1200">
        <div class="top_tit">
          <h3>在线考试</h3>
          <a href="javascript:;" class="study_prv" title="上一页" @click="page_click('prev')"></a>
          <a href="javascript:;" class="study_next" title="下一页" @click="page_click('next')"></a>
        </div>
        <div class="list">
          <a href="javascript:;" v-for="item in examList" :key="item.id" @click="exam_detail(item, '0')">
            <dl>
              <dt>
                <img v-if="item.faceUri" :src="item.faceUri" :title="item.title" />
                <img v-if="!item.faceUri || item.faceUri==''" src="@/assets/images/test_img.jpg" :title="item.title" />
                <span class="price_r" v-if="item.isPurchase =='0' && item.isFree=='0'">￥{{parseFloat(item.point).toFixed(2)}}</span>
                <span class="price_r" v-if="item.isFree=='1'">免费</span>
                <span class="price_r" v-if="item.isFree=='0' && item.isPurchase =='1'">已购买</span>
                <span class="man_num_r" v-if="!item.isUsed || item.isUsed=='0'">0</span>
                <span class="man_num_r" v-if="item.isUsed && item.isUsed!='0'">{{item.isUsed}}</span>
              </dt>
              <dd>
                <h3>{{item.title}}</h3>
                <p class="font_red" v-if="item.isPurchase =='0' && parseFloat(item.point)>0 && item.isFree=='0'">未购买</p>
                <p class="font_blue" v-if="item.isPurchase =='1' && (!item.userCntTest || item.userCntTest=='0')">未考试</p>
                <p class="font_yellow" v-if="item.isPurchase =='1' && item.userCntTest>'0' && item.userScore<item.passline">未通过</p>
                <p class="font_green" v-if="item.isPurchase =='1' && item.userCntTest>'0' && item.userScore>=item.passline">已通过</p>
              </dd>
            </dl>
          </a>
        </div>
      </div>
    </div>
    <!--/课件列表-->
  </div>
</template>
<script>
export default {
  components: { },
  data () {
    return {
      filter: {
        largeType: '',
        pageNo: 1,
        pageSize: 12,
        title: '',
        type: '1'
      },
      largeTypeList: [],
      trees: [],
      teacherList: [],
      examList: [],
      currentPage: 1,
      pages: 0
    }
  },
  created () {
    this.getExams(this.filter)
    this.getClassifications()
    // this.getTeachers()
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  computed: {},
  methods: {
    page_click (type) {
      if (type=='prev') {
        if (this.currentPage > 1) {
          this.filter.pageNo = this.currentPage - 1
          this.currentPage--
          this.getExams(this.filter)
        }
      } else if (type=='next') {
        if (this.currentPage < this.pages) {
          this.filter.pageNo = this.currentPage + 1
          this.currentPage++
          this.getExams(this.filter)
        }
      }
    },
    searchByFilter (classificationId, title, event) {
      this.currentPage = 1
      this.filter.pageNo = 1
      if (event != null) {
        $(event.target).siblings('a').removeClass("focus")
        $(event.target).addClass('focus')
      }
      if (classificationId != null) {
        this.filter.largeType = classificationId
      }
      if (title != null) {
        this.filter.title = title
      }
      this.getExams(this.filter)
    },
    getClassifications () {
      this.$api.post(this.$global.examApiPath, '/dict/get', {type: "examLargeType"}, r => {
        this.largeTypeList = r.data
      })
    },
    getExams (filter) {
      this.$api.post(this.$global.examApiPath, '/examPaper/searchByUser', filter, r => {
        if (r.data && r.data.length>0) {
          this.examList = r.data
          this.pages = Math.ceil(r.cntData / this.filter.pageSize)
        } else {
          this.examList = []
          this.pages = 0
        }
      })
    },
    getCourseClassification () {
      this.$api.get(this.$global.courseApiPath, '/course/classificatio/list', {}, r => {
        this.trees = r.data
      })
    },
    getTeachers () {
      this.$api.post(this.$global.teacherApiPath, '/teacher/teachers', {delFlag: '0'}, r => {
        if (r.data && r.data.length>0) {
          this.teacherList = r.data
        }
      })
    },
    exam_detail (item, type) {
      if (item.isPurchase=='0' && item.isFree!='1') {
        this.$router.push({path: '/byl/examPayAbout/'+ item.id})
      } else if (item.isPurchase=='1' || item.isFree=='1') {
        this.$router.push({path: '/byl/examReady/'+ item.id + '/' + type})
      }
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/modules/exam/list.vue